module.exports = __webpack_public_path__ + "static/img/banner9.91bb8f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner9.jpg
// module id = Fa3e
// module chunks = 73